<!-- 销售器械订单数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div>
                                    <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo"
                                        ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <el-form-item :label="formOneValue.chineseField"
                                                v-for="(formOneValue, formOneKey) in jurconfigform" :key="formOneKey"
                                                :prop="formOneValue.entityField"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.chineseField)"
                                                    v-html="$common.htmlLabel(formOneValue.chineseField)"></label>
                                                <!-- 日期 -->
                                                <df-date v-if="formOneValue.fieldType == 'date'"
                                                    v-model="sendDataInfo[formOneValue.entityField]"
                                                    :isdisabled="formOneValue.isChange == 0" :isShowLong="false">
                                                </df-date>
                                                <!-- 检索方案 -->
                                                <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                <el-input clearable
                                                    v-model="sendDataInfo[formOneValue.entityField]"
                                                    :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                    :disabled="formOneValue.isChange == 0">
                                                    <el-button
                                                        @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                        slot="append" icon="el-icon-search"
                                                        :disabled="formOneValue.isChange == 0">
                                                    </el-button>
                                                </el-input>
                                                </el-tooltip>
                                                <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                <el-select clearable size="mini"
                                                    v-else-if="formOneValue.fieldType == 'formatter'"
                                                    @visible-change="selectChange" :disabled="formOneValue.isChange == 0"
                                                    @change="$forceUpdate()"
                                                    v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)"
                                                        :key="item.key" :label="item.key" :value="item.value">
                                                    </el-option>
                                                </el-select>
                                                <!-- 账期 -->
                                                <el-input @keyup.enter.native="nextFocus(formOneKey)" type="number"
                                                    v-else-if="formOneValue.entityField == 'credit'"
                                                    :disabled="formOneValue.isChange == 0"
                                                    v-model="sendDataInfo[formOneValue.entityField]"
                                                    :maxlength="$store.state.inputLength"></el-input>
                                                <!-- string类型 -->
                                                <el-input @keyup.enter.native="nextFocus(formOneKey)" v-else
                                                    :disabled="formOneValue.isChange == 0"
                                                    v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                    :maxlength="$store.state.inputLength"></el-input>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <!-- 上传图片 -->
                                    <div class="pic_box">
                                        <div class="pic_content" v-for="(item, index) in imgDateList" :key="index">
                                            {{ item.name }}
                                            <el-upload class="avatar-uploader" :action="requesUrl + '/upload/fileupload'"
                                                :show-file-list="false" :headers='token'
                                                :on-success="(res, field) => { handleAvatarSuccess(res, field, item) }">
                                                <img v-if="sendDataInfo[item.prop]"
                                                    :src="$store.getters.getConfig.imgUrl + '/' + sendDataInfo[item.prop]"
                                                    class="avatar">
                                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                            </el-upload>
                                        </div>
                                    </div>
                                    <!-- 明细操作 -->
                                    <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                        <el-button type="primary" size="mini" @click="addDetail()">
                                            新增明细</el-button>
                                        <el-button type="primary" size="mini" @click="deleteDetails()"
                                            :disabled="sendDataInfo.detailList.length < 1">删除明细</el-button>
                                        <el-input style="min-width: 300px; max-width: 40%; margin: 0 10px;" autosize
                                            placeholder="扫码录入" v-model="udicode">
                                        </el-input>
                                        <el-button type="primary" size="mini" @click="pscharesoudi"
                                            :disabled="flag">确定录入</el-button>
                                    </div>
                                    <!-- 明细信息 -->
                                    <el-table class="baseTable" ref="mxTableRef" :height="mxHeight"
                                        :data="sendDataInfo.detailList" :row-class-name="rowClassName" :row-style="rowStyle"
                                        @row-click="clickEvent" @selection-change="handleSelectionChange" border
                                        size="mini">
                                        <el-table-column width="80" label="选择" v-if="dataActionBox.actionType != 2">
                                            <template slot-scope="scope">
                                                <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border
                                                    size="mini">
                                                    <i class="el-icon-thumb"></i>
                                                </el-radio>
                                            </template>
                                        </el-table-column>
                                        <el-table-column :prop="formOneValue.entityField" :label="formOneValue.chineseField"
                                            v-for="(formOneValue, formOneKey) in mxTableData" :key="formOneKey"
                                            :min-width="formOneValue.fieldWeight" show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <!-- 检索方案 -->
                                                <el-input
                                                    v-if="formOneValue.fieldType == 'search' && formOneValue.entityField == 'bgmName'"
                                                    clearable
                                                    v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                                    :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="openDetailSearch(formOneValue.entityField, formOneValue.setField, scope.$index)">
                                                    <el-button
                                                        @click="openDetailSearch(formOneValue.entityField, formOneValue.setField, scope.$index)"
                                                        slot="append" icon="el-icon-search">
                                                    </el-button>
                                                </el-input>
                                                <span v-else-if="formOneValue.isRift == 1">
                                                    <a
                                                        @click="toDetail(sendDataInfo.detailList[scope.$index][formOneValue.riftField])">
                                                        {{
                                                            sendDataInfo.detailList[scope.$index][formOneValue.entityField]
                                                        }}</a>
                                                </span>

                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span
                                                        v-if="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                                        {{
                                                            $common.getLocalTime(sendDataInfo.detailList[scope.$index][formOneValue.entityField])
                                                        }}
                                                    </span>
                                                </span>
                                                <el-input
                                                    @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                    :ref="formOneValue.entityField"
                                                    v-else-if="formOneValue.entityField == 'useNum' && dataActionBox.actionType != 2"
                                                    v-model.trim="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                                </el-input>
                                                <span v-else>
                                                    {{ sendDataInfo.detailList[scope.$index][formOneValue.entityField]
                                                    }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <div style="text-align: center;">
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
                            @click="showPrintPlan">打印</el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 0">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 1">保存</el-button>
                    </div>
                    <div style="text-align: center;" v-if="footForm">
                        <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
                            <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                                <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>

        </div>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true"
            :append-to-body="true">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
                <el-table-column prop="validity" label="有效期" min-width="100">
                    <template slot-scope="{row}">
                        {{ $common.getLocalTime(row.validity) }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
                @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
import * as afterSales from '@/components/improveAfterSalesInformation.js'
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";

export default {
    name: "improveAfterSalesInformation",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
    },
    data() {
        //这里存放数据
        return {
            mxTableData: afterSales.tabledata,
            token: {
                token: sessionStorage.getItem("token"),
            },
            imgIndex: 0,
            imgDateList: [
                {
                    name: '出库图片',
                    key: 0,
                    prop: "outImg",

                },
                {
                    name: '入库图片',
                    key: 1,
                    prop: "inImg",
                },
                {
                    name: 'X光片',
                    key: 2,
                    prop: "xgImg",
                },
                {
                    name: '合格证',
                    key: 3,
                    prop: "standardImg",
                },
            ],
            //----------------------------
            showDialog: false,
            flag: -1,
            dialogList: [],
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            inputel: '', //所有input对象
            detaislDataInfo: {},
            showTabs: "",
            formDataList: [],
            selectedDetailsIndex: 0,
            mxHeight: 0,
            isLoaded: false,
            parentSearchData: {
                orderType: 1,   //	订单类型0.药品1.器械
                woamId: ""
            },
            selectedRow: [], // 当前已选择行
            jurconfigform: [],//表单数据
            tabForm: [], // tab循环的主表单
            footForm: [],
            seTitle: "", //检索
            DialogVisible: false,
            seId: 919354910904320,
            seType: "",
            seIndex: 0,
            seWidth: "0",
            sField: '', // 赋值字段
            requesUrl: '',
            udicode: "",
            flag: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        //扫码录入查询批号
        async pscharesoudi() {
            if (this.udicode == "") {
                this.$message.error("请扫码录入")
                return
            }
            this.flag = true
            const responseData = await this.$http.pscharesoudi({
                qrcode: this.udicode,
                bgmId: "",
            })
            this.flag = false
            if (responseData.status == 200) {
                this.add(responseData.result)
            } else {
                this.$message.error(responseData.message)
                this.add("udicode")
            }
        },
        add(val) {
            var flag = false
            if (this.sendDataInfo.detailList.length > 0) {
                this.sendDataInfo.detailList.forEach((item, index) => {
                    if (item.bgmCode == "") {
                        flag = true
                        this.$nextTick(() => {
                            this.selectedDetailsIndex = index
                            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                            let refsElTable = this.$refs.mxTableRef;
                            refsElTable.clearSelection();
                            refsElTable.toggleRowSelection(
                                this.sendDataInfo.detailList[this.selectedDetailsIndex]
                            );
                        });
                    }
                })
            }
            if (!flag) {
                this.sendDataInfo.detailList.push(
                    JSON.parse(JSON.stringify(this.detaislDataInfo))
                );
                this.selectedDetailsIndex = Number(
                    this.sendDataInfo.detailList.length - 1
                );
            }
            this.$nextTick(() => {
                this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                let refsElTable = this.$refs.mxTableRef;
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(
                    this.sendDataInfo.detailList[this.selectedDetailsIndex]
                );
            });
            if (val == 'udicode') {
                this.sendDataInfo.detailList[this.selectedDetailsIndex].udicode = this.udicode
                return
            }
            for (const key in this.detaislDataInfo) {
                this.$set(this.sendDataInfo.detailList[this.selectedDetailsIndex], key, val[key])
            }
            this.$set(this.sendDataInfo.detailList[this.selectedDetailsIndex], 'woadId', val['woadId'])
            this.$set(this.sendDataInfo.detailList[this.selectedDetailsIndex], 'useNum', 1)
            this.$set(this.sendDataInfo.detailList[this.selectedDetailsIndex], 'psprice', 0)
            this.$set(this.sendDataInfo.detailList[this.selectedDetailsIndex], 'price', 0)
            this.sendDataInfo.detailList[this.selectedDetailsIndex].udicode = this.udicode
            this.productQuery(val)
        },
        //根据批号查询商品明细
        async productQuery(val) {
            const params = {
                batchno: val.batchno,
                expidate: val.expidate,
                bgmId: val.bgmId,
                prodate: val.prodate,
                sterBatchno: val.sterBatchno,
                woamId: this.sendDataInfo.woamId
            }
            const responseData = await this.$http.highvaluequeryWoadId(params)
            if (responseData.status == 200) {
                this.sendDataInfo.detailList[this.selectedDetailsIndex].woadId = responseData.result
                this.udicode = ""
            } else {
                for (const key in this.sendDataInfo.detailList[this.selectedDetailsIndex]) {
                    this.sendDataInfo.detailList[this.selectedDetailsIndex][key] = ""
                }
                this.$message.error(responseData.message)
            }
        },
        blur(entityField, index) {
            this.sendDataInfo.detailList[index][entityField] = this.$common.getDecimalInfo(2, this.sendDataInfo.detailList[index][entityField]);
        },
        handleAvatarSuccess(res, file, e) {
            this.$set(this.sendDataInfo, e.prop, res.result[0].fileUrl)
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        //新增明细
        addDetail(sendDataInfo) {
            var flag = false
            if (this.sendDataInfo.detailList.length > 0) {
                this.sendDataInfo.detailList.forEach(item => {
                    if (item.bgmCode == "") {
                        flag = true
                        this.$nextTick(() => {
                            this.selectedDetailsIndex = Number(
                                this.sendDataInfo.detailList.length - 1
                            );
                            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                            let refsElTable = this.$refs.mxTableRef;
                            refsElTable.clearSelection();
                            refsElTable.toggleRowSelection(
                                this.sendDataInfo.detailList[this.selectedDetailsIndex]
                            );
                        });
                    }
                })
            }
            if (flag) {
                this.$message.error("请勿重复添加空白行")
                return
            }
            this.sendDataInfo.detailList.push(
                JSON.parse(JSON.stringify(this.detaislDataInfo))
            );
            this.$nextTick(() => {
                this.selectedDetailsIndex = Number(
                    this.sendDataInfo.detailList.length - 1
                );
                this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                let refsElTable = this.$refs.mxTableRef;
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(
                    this.sendDataInfo.detailList[this.selectedDetailsIndex]
                );
            });
        },
        //删除明细
        deleteDetails() {
            this.sendDataInfo.detailList.splice(this.selectedDetailsIndex, 1);
            this.$nextTick(() => {
                if (this.sendDataInfo.detailList.length > 1) {
                    this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1)
                    this.tableNextFocus('bgmName', this.selectedDetailsIndex)
                    let refsElTable = this.$refs.mxTableRef
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]);
                } else {
                    this.selectedDetailsIndex = 0
                }
            })
        },
        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(index, type) {
            this.seType = type
            this.seIndex = index
            this.parentSearchData[type] = this.sendDataInfo.detailList[index][type]
            this.parentSearchData['woamId'] = this.sendDataInfo['woamId']
            this.DialogVisible = true
        },
        openDetailSearch(type, setField, index) {
            this.seType = type
            this.seIndex = index
            this.parentSearchData[type] = this.sendDataInfo.detailList[index][type]
            this.parentSearchData['woamId'] = this.sendDataInfo['woamId']
            this.DialogVisible = true
        },
        changeInputModel(val) {
            console.log("返回", val);
            if (val != "" && val != undefined) {
                this.DialogVisible = false;
                for (const key in this.detaislDataInfo) {
                    if (key == 'useNum' || key == 'psprice' || key == 'price') {
                        this.$set(this.sendDataInfo.detailList[this.seIndex], 'useNum', 1)
                        this.$set(this.sendDataInfo.detailList[this.seIndex], 'psprice', 0)
                        this.$set(this.sendDataInfo.detailList[this.seIndex], 'price', 0)
                    } else {
                        this.$set(this.sendDataInfo.detailList[this.seIndex], key, val[key])
                    }
                }
                this.$set(this.sendDataInfo.detailList[this.seIndex], 'woadId', val['woadId'])
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            this.$nextTick(() => {
                this.nextFocus(this.seIndex)
            })
        },

        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 打印方法
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        //确认新增
        async sendDataAction(formName1) {
            let flag = false;
            this.$refs[formName1].validate((valid) => {
                if (valid) { } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
            if (flag) return false;
            var responseData = await this.$http.addAftersaleHighvalue(this.sendDataInfo);
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel");
                this.init();
            } else {
                this.$message.error(responseData.message)
            }
        },
        //取消
        initActionBox(formName1, formName2) {
            this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel");
                    this.init();
                    this.$refs[formName1].resetFields();
                    this.$refs[formName2].resetFields();
                })
                .catch(() => { });
        },

        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "detailList") {
                    this.sendDataInfo[key] = []
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            this.sendDataInfo.woamSaledate = this.$moment().valueOf();

            this.sendDataInfo.detailList = [];
            this.sendDataInfo.totalCount = 0;
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.orderType = 1;   //orderType	订单类型0.药品订单1.器械订单
        },
        //上级流入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            this.tabForm = JSON.parse(afterSales.jurFormVoList)
            this.jurconfigform = JSON.parse(afterSales.jurFormVoList)[0].jurconfigform
            this.mxTableData = afterSales.tabledata
            this.filterMainField()
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.init();
            if (this.dataActionBox.actionType == 0) {

            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                for (const key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key])
                }
                this.$set(this.sendDataInfo, "orderType", 1)//orderType	订单类型0.药品订单1.器械订单
                this.$set(this.sendDataInfo, "detailList", [])
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight() - 180
                    } else {
                        this.mxHeight = this.$common.getHeight() - 180
                    }
                    this.initFocus()
                }, 16.7)
            });
        },
        filterMainField() {
            this.jurconfigform.forEach(item => {
                if (item.fieldType == 'number') {
                    this.$set(this.sendDataInfo, item.entityField, 0)
                } else if (item.fieldType == 'search' && item.setField) {
                    var arr = item.setField.split(",")
                    arr.forEach(item1 => {
                        this.$set(this.sendDataInfo, item1, "")
                    })
                } else {
                    this.$set(this.sendDataInfo, item.entityField, "")
                }
            })
            this.imgDateList.forEach(item => {
                this.$set(this.sendDataInfo, item.prop, "")
            })
            this.$set(this.sendDataInfo, 'detailList', [])
            this.mxTableData.forEach(item => {
                if (item.fieldType == 'number') {
                    this.$set(this.detaislDataInfo, item.entityField, 0)
                } else if (item.fieldType == 'search' && item.setField) {
                    var arr = item.setField.split(",")
                    arr.forEach(item1 => {
                        this.$set(this.detaislDataInfo, item1, "")
                    })
                } else {
                    this.$set(this.detaislDataInfo, item.entityField, "")
                }
            })
        },

        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },

        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index)
                        break
                    }
                }
            }
        },

        // 输入框切换焦点
        nextFocus(index) {
            console.log(index, '切换', this.inputel.length)
            if (index >= (this.inputel.length - 1)) {
                if (this.sendDataInfo.detailList.length > 0) { }
                return
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },

        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '') {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        closeChild() {
            addEventListener('keyup', this.keyUp) //创建监听键盘事件
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            this.seIndex = index;
            if (field == 'keydown') {
                if (this.sendDataInfo.detailList[index + 1] != undefined) {
                    this.$refs['price'][index + 1].focus()
                    this.selectedDetailsIndex = index + 1
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]);
                    })
                    return
                }
                return
            }
            this.$refs[field][index].focus()
        },
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == 'F2') {
                e.preventDefault();
                this.deleteDetails()
            } else if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.sendDataInfo.detailList.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == this.sendDataInfo.detailList.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0
                    } else { // 正常递增
                        this.selectedDetailsIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.sendDataInfo.detailList.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex = this.sendDataInfo.detailList.length - 1
                    } else { // 正常递减
                        this.selectedDetailsIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            }

        },

        // 表格方法
        rowClassName({
            row,
            rowIndex
        }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({
            row,
            rowIndex
        }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {}
            this.selectedDetailsIndex = row.rowIndex
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgur()

        this.$nextTick(() => {
            this.openBox();

            this.isLoaded = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // addEventListener('keydown', this.keyDown)
        addEventListener('keyup', this.keyUp) //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUp)
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style  scoped>
.pic_box {
    width: 100%;
    padding: 10px;
    height: 160px;
    display: flex;
    justify-content: space-around;

}

.pic_content {
    width: 25%;
    /* display: flex; */
    /* float: left; */
    /* height: 200px; */
}

.avatar-uploader .el-upload {
    border: 1px dashed #4d4d4d !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}

.avatar {
    width: 100px;
    height: 100px;
    display: block;
}



.table_button_box {
    height: 200px;
    background-color: red;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

.el-table .rowStyle {
    background: #fff7ca !important;
}

::v-deep .pic_content .avatar-uploader .el-upload {
    border: 1px dashed #4d4d4d !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .pic_content .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

::v-deep .pic_content .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}

::v-deep .pic_content .avatar {
    width: 100px;
    height: 100px;
    display: block;
}
</style>